import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CSSTransition } from 'react-transition-group'

import { alertIconMap } from 'library/utils/iconMaps'
import styles from './styles.module.scss'

const AlertText = React.forwardRef(
  (
    { children, hasIcon, className, isVisible, as, variant, ...props },
    forwardedRef
  ) => {
    let Component = 'div'
    if (as) Component = as

    return (
      <CSSTransition
        classNames={{
          // appear: 'my-appear',
          // appearActive: 'my-active-appear',
          // appearDone: 'my-done-appear',
          enter: styles[`slideDown-enter`],
          enterActive: styles[`slideDown-enter-active`],
          enterDone: styles[`slideDown-enter-done`],
          exit: styles[`slideDown-exit`],
          exitActive: styles[`slideDown-exit-active`],
        }}
        timeout={300}
        in={isVisible}
        unmountOnExit
        ref={forwardedRef}
        // Should we support a closable alert text?
        // onExited={handleClose}
        {...props}
      >
        <Component
          ref={forwardedRef}
          className={classNames(
            styles.alertText,
            variant && styles[variant],
            className
          )}
          {...props}
        >
          {hasIcon && (
            <>
              <FontAwesomeIcon icon={alertIconMap[variant]} />{' '}
            </>
          )}
          {children}
        </Component>
      </CSSTransition>
    )
  }
)

AlertText.defaultProps = {
  variant: 'info',
  isVisible: true,
  hasIcon: true,
  icon: null,
}

AlertText.propTypes = {
  /**
   * Visual style of the alert text
   */
  variant: PropTypes.oneOf([
    'default',
    'primary',
    'secondary',
    'light',
    'dark',
    'success',
    'warning',
    'danger',
    'info',
  ]),
  /**
   * Determines whether or not the alert text is shown
   */
  isVisible: PropTypes.bool,
  /**
   * Determines whether or not to show the alert text's icon
   * We implicitly determine the icon by the variant.
   */
  hasIcon: PropTypes.bool,
  /**
   * Overrides the default icon for each variant
   */
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
}

AlertText.displayName = 'AlertText'

export default AlertText
